import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from '@/state/types/notification'

const defaultState = {
  queue: [],
  // text: '',
  // type: 'info' // one of 'info', 'confirm', 'warning'
}

export default (previousState = defaultState, { type, payload } = {}) => {
  let queue
  switch (type) {
    case SHOW_NOTIFICATION:
      queue = previousState.queue.slice()
      queue.push({ id: payload.id, text: payload.text, data: payload.data })
      return { queue }
    // return { text: payload.text, type: payload.type }
    case HIDE_NOTIFICATION:
      queue = previousState.queue.filter(snack => {
        return snack.id !== payload.id
      })
      return { queue }
    // return { ...previousState, text: '' }
    default:
      return previousState
  }
}



// WEBPACK FOOTER //
// ./state/reducers/notification.js